/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "common": {
                        "nested": {
                          "DepositAccount": {
                            "values": {
                              "DEPOSIT_ACCOUNT_UNSPECIFIED": 0,
                              "DEPOSIT_ACCOUNT_UNKNOWN": 1,
                              "DEPOSIT_ACCOUNT_CASH_APP_2076": 2,
                              "DEPOSIT_ACCOUNT_SQUARE_BANKING_4580": 3
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.common?.nested?.DepositAccount) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DepositAccount @ squareup/cash/gambit/api/v1/common/deposit_account.proto at 7:1
 */
export const DepositAccount = $root.lookupEnum('squareup.cash.gambit.api.v1.common.DepositAccount').values;